/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot reloadable.
 */

import Immutable, { type Map } from 'immutable';
import type { Reducer } from 'redux';
import { reducer as formReducer } from 'redux-form/immutable';
import { combineReducers } from 'redux-immutable';
import appReducer from './containers/App/reducer';
import { authReducer } from './containers/IntegrationSettings/Integrations/redux/auth/reducer';
import { integrationsReducer } from './containers/IntegrationSettings/Integrations/systems';
import languageProviderReducer from './containers/LanguageProvider/reducer';
import type { LegacyAction } from './middleware/api-middleware.types';
import customerBackendDashboardRootReducer from './reducers/index';
import type { LegacyReducer } from './utils/check-store';

export type LegacyRootState = Map<string, unknown>;
export type LegacyReducerRegistry = Record<string, LegacyReducer>;

export default function createReducer(
  injectedReducers: LegacyReducerRegistry = {},
): Reducer<LegacyRootState, LegacyAction> {
  const combinedReducer = combineReducers({
    global: appReducer,
    language: languageProviderReducer,
    customerBackendDashboard: customerBackendDashboardRootReducer,
    form: formReducer,
    Auth: authReducer,
    integrations: integrationsReducer,
    ...injectedReducers,
  });

  return (state, action) => {
    const nextState: unknown = Reflect.apply(combinedReducer, undefined, [
      state,
      action,
    ]);

    if (!Immutable.Map.isMap(nextState)) {
      throw new TypeError(
        'Expected the combined Redux state to be an Immutable Map',
      );
    }

    return nextState as LegacyRootState;
  };
}
